import type { CatalogueEntry } from "../types";
import imageLight from "../images/building-roof.light.webp";
import imageDark from "../images/building-roof.dark.webp";

export const entry: CatalogueEntry = {
  slug: "building-roof",
  displayName: `Building Roof`,
  datasetProductCode: `BUILDING-ROOF`,
  subtitle: `Roof Colour, Shape, Slope and Material for Australian Buildings`,
  shortDescription: `The Building Roof Insight Pack is a national digital dataset representing roof information for buildings across all Australian states and territories. It includes roof colour, roof shape, roof slope and the primary roof material, along with a tree overhang flag.
Building Roof is an insight pack that extends the National Buildings product. Each record links 1:1 to a building in the Buildings product through the building_pid, so roof insights can be joined directly to building footprints and their related property, cadastre and address data.`,
  metadata: {
    dateAdded: 1787270400000,
    dataType: ["Aspatial"],
    theme: `Built Environment`,
    totalFeatureCount: 19073237,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/building_roof_insight_pack/en/stable/index.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/building_roof_insight_pack/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `Building Roof National Buildings Insight Pack Roof Colour Roof Shape Roof Slope Roof Material Tree Overhang Solar Insurance Risk Hail Bushfire Property Insights Urban Planning Aerial Imagery Geoscape Buildings Roof`,
  detail: () => import("../details/building-roof").then((m) => m.detail),
};

export default entry;
